import React, { Component } from "react";

import "css/Popup.css";

class Popup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    render() {
        let { children, component: Component, render, ...otherProps } = this.props;

        return (

            <div className="Popup-container">
                <this.props.children.type {...children.props} onClick={() => this.setState({ open: true })} />

                <div className={`Popup ${this.state.open ? "":"hide"}`}>
                    <div className="window">
                        <div className="close-button" onClick={() => this.setState({ open: false })}>
                            &times;
                        </div>

                        {Component &&
                            <Component {...otherProps} />}
                        {render && render(otherProps)}
                    </div>
                </div>
            </div>

        );
    }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup.js